import React from 'react';
import PropTypes from 'prop-types';

import { formatRateSummary } from 'v1/helpers/budgetHelper';
import {
  Grid,
  GridCell,
  Label,
  NumberInput,
  RateInput
} from 'v1/components/shared';
import { EntityType } from '__types__';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from 'v5/design-system/Popover.js';

const RateEditFlyoverUI = ({
  rate,
  defaultCurrency,
  type,
  onRateChange,
  onClose
}) => {
  const formattedRate = {
    ...rate,
    amount: rate.amount,
    currency: rate.currency || defaultCurrency
  };

  const handleCloseRateFlyover = () => {
    if (
      formattedRate &&
      (!formattedRate.quantity || isNaN(formattedRate.quantity))
    ) {
      onRateChange({ ...formattedRate, quantity: 1 });
    }
    onClose?.();
  };

  return (
    <Popover onOpenChange={open => !open && handleCloseRateFlyover()}>
      <PopoverTrigger asChild>
        {rate && rate.amount ? (
          <div className="inset-S text-13-600">
            {formatRateSummary(rate, defaultCurrency)}
          </div>
        ) : (
          <div className="inset-S text-13-600-eggplant-lightest">Add rate</div>
        )}
      </PopoverTrigger>
      <PopoverContent className="w-(--radix-popover-trigger-width)">
        <div className={!rate.isBookingRate ? 'stack-S' : ''}>
          <RateInput
            size="S"
            appearance="underline"
            type={type === 'EXPENSE' ? EntityType.EXPENSE : EntityType.BOOKING}
            value={formattedRate}
            onBlur={(v, key) => {
              onRateChange({ ...formattedRate, ...v }, key);
            }}
          />
        </div>
        {!rate.isBookingRate && (
          <Grid gutters="S">
            <GridCell width="auto">
              <Label>Quantity</Label>
            </GridCell>
            <GridCell width="1/4">
              <NumberInput
                appearance="underline"
                size="S"
                value={formattedRate.quantity}
                placeholder="Qty"
                onBlur={v =>
                  onRateChange({ ...formattedRate, quantity: v }, 'quantity')
                }
              />
            </GridCell>
          </Grid>
        )}
      </PopoverContent>
    </Popover>
  );
};

RateEditFlyoverUI.propTypes = {
  rate: PropTypes.object,
  defaultCurrency: PropTypes.string,
  type: PropTypes.string,
  onRateChange: PropTypes.func.isRequired,
  onClose: PropTypes.func
};

export default RateEditFlyoverUI;
